import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";

import Vue from "vue";
import Vuelidate from "vuelidate";
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import App from "@/app.vue";

import VueResource from "vue-resource";
import BootstrapVue from "bootstrap-vue";
import VueSweetalert2 from "vue-sweetalert2";
import Snotify from "vue-snotify";
import helpers from "@/plugins/helpers";
import VueCurrencyFilter from "vue-currency-filter";
import DatePicker from "vue2-datepicker";

Vue.config.productionTip = process.env.NODE_ENV === "production" || false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueResource);
Vue.use(VueSweetalert2);
Vue.use(Snotify);
Vue.use(helpers, { $store: store, $router: router, $t: i18n, $swal: Vue.swal });
Vue.use(DatePicker);
Vue.use(VueCurrencyFilter, {
  symbol: "",
  thousandsSeparator: ",",
  fractionCount: 2,
  fractionSeparator: ".",
  symbolPosition: "front",
  symbolSpacing: false
});

import moment from "moment";
Object.defineProperty(Vue.prototype, "$moment", { value: moment });

import numeral from "numeral";
Object.defineProperty(Vue.prototype, "$numeral", { value: numeral });

global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;

/* eslint-disable no-new */

router.beforeEach((to, from, next) => {
  let query = to.fullPath.match(/^\/$/) ? {} : { redirect: to.fullPath };
  let path = "/denied";

  if (
    to.matched.some(record => {
      return record.meta.requiredLoggedIn && record.meta.includedPages;
    })
  ) {
    if (!store.getters.isLoggedIn) {
      next({ path: path, query: query });
      return;
    }

    let haveRole = false;
    let pages = to.matched[0].meta.includedPages;
    let roles = store.getters.accessRoles;
    for (var i = 0; i < pages.length; i++) {
      for (var j = 0; j < roles.length; j++) {
        if (roles[j].page_id == pages[i]) {
          haveRole = true;
          break;
        }
      }
    }
    if (haveRole == false) {
      next({ path: path, query: query });
      return;
    }
  }

  next();
});

i18n.locale = store.state.layout.language;
// i18n.locale = "zh";

export const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
